import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { GrupoUsuarioService } from 'src/services/grupo-usuario.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { PessoaService } from 'src/services/pessoa.service';
import { UsuarioService } from 'src/services/usuario.service';
import { ConfirmationService } from 'primeng/api';
import { distinctUntilChanged, Subscription } from 'rxjs';

@Component({
    selector: 'app-usuario',
    templateUrl: './usuario.component.html',
    styleUrls: ['./usuario.component.scss'],
    standalone: false
})
export class UsuarioComponent implements OnInit, AfterViewInit {
  data: any[] = []
  form: FormGroup;
  formApi: FormGroup;
  readonly defaultUserImage = 'assets/layout/images/avatar.png';
  displayModal: boolean = false
  displayModalApi: boolean = false
  apiKeyDownloaded: boolean = false;
  secretDownloaded: boolean = false;
  isEditing: boolean = false;
  loading: boolean = false
  enviandoConviteId: number | null = null
  dropDownEmpresas: any[] = []
  dropDownGrupos: any[] = []
  private perfisPorId = new Map<string, string>();
  imagePreviewUrl: string | null = null;
  selectedImageFile: File | null = null;
  imagemRemovida = false;
  isUploading = false;
  private isRefreshingPreviewImage = false;
  private lastRetriedPreviewImageUrl: string | null = null;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';

  private empresaIdSubscription: Subscription;
  private usuarioInternoSubscription: Subscription;
  private gruposRequestId = 0;
  user: any = {};
  constructor(
    protected _formBuilder: FormBuilder,
    protected usuarioService: UsuarioService,
    protected pessoaService: PessoaService,
    protected _grupoUsuarioService: GrupoUsuarioService,
    protected permissaoService: PermissoesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) { }

  /** Externo: `usuario_interno` do token/localStorage não é estritamente `true`. */
  get isUsuarioExterno(): boolean {
    return this.user?.usuario_interno !== true;
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user') ?? '{}');
    this.form = this._formBuilder.group({
      id: [null],
      ativo: [null],
      name: [null, Validators.required],
      empresa_id: [null],
      email: [null, Validators.required],
      password: [null],
      grupo_usuario_id: [null],
      usuario_interno: [null],
      api_key: [null],
      secret: [null],
      url_imagem_usuario: [null],
    })
    this.formApi = this._formBuilder.group({
      id: [null],
      ativo: [null],
      name: [null, Validators.required],
      empresa_id: [null],
      email: [null, Validators.required],
      password: [null],
      grupo_usuario_id: [null],
      usuario_interno: [null],
      api_key: [null],
      secret: [null],
      url_imagem_usuario: [null],
    })
    this.index()
    this.listPerfisParaListagem()
    this.listEmpresas()
    this.setupUsuarioInternoObserver();
    this.setupEmpresaIdObserver();
  }

  private normalizeBoolean(value: any): boolean {
    return value === true || value === 1 || value === '1';
  }

  private areSameValue(a: any, b: any): boolean {
    return String(a) === String(b);
  }

  private extractGrupoUsuarioId(usuario: any): any {
    if (usuario?.grupo_usuario_id !== undefined && usuario?.grupo_usuario_id !== null) {
      return usuario.grupo_usuario_id;
    }

    if (usuario?.grupo_usuario && typeof usuario.grupo_usuario === 'object' && usuario.grupo_usuario.id !== undefined && usuario.grupo_usuario.id !== null) {
      return usuario.grupo_usuario.id;
    }

    if (usuario?.grupo_usuario !== undefined && usuario?.grupo_usuario !== null && typeof usuario.grupo_usuario !== 'object') {
      return usuario.grupo_usuario;
    }

    return null;
  }

  isGrupoUsuarioNaoSelecionado(grupoUsuarioId: any = this.form?.get('grupo_usuario_id')?.value): boolean {
    return grupoUsuarioId === null
      || grupoUsuarioId === undefined
      || grupoUsuarioId === ''
      || grupoUsuarioId === 'null';
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  onImageUpload(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    if (!file.type?.startsWith('image/')) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Arquivo inválido',
        detail: 'Selecione um arquivo de imagem válido.',
      });
      return;
    }

    this.selectedImageFile = file;
    this.imagemRemovida = false;
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreviewUrl = typeof reader.result === 'string' ? reader.result : null;
    };
    reader.readAsDataURL(file);
  }

  onPreviewImageError(event: Event): void {
    const img = event.target as HTMLImageElement | null;
    if (!img || img.src.includes(this.defaultUserImage)) {
      return;
    }

    const usuarioId = this.form.get('id')?.value;
    const currentImageUrl = this.form.get('url_imagem_usuario')?.value || null;

    if (!usuarioId || this.isRefreshingPreviewImage || !currentImageUrl) {
      img.src = this.defaultUserImage;
      return;
    }

    if (this.lastRetriedPreviewImageUrl === currentImageUrl) {
      img.src = this.defaultUserImage;
      return;
    }

    this.lastRetriedPreviewImageUrl = currentImageUrl;
    this.isRefreshingPreviewImage = true;
    this.usuarioService.show(usuarioId).subscribe({
      next: (json) => {
        const renewedUrl = json?.url_imagem_usuario ?? null;
        this.form.patchValue({
          url_imagem_usuario: renewedUrl,
        });

        if (!renewedUrl || renewedUrl === currentImageUrl) {
          img.src = this.defaultUserImage;
          return;
        }

        this.imagePreviewUrl = this.selectedImageFile ? this.imagePreviewUrl : renewedUrl;
        this.lastRetriedPreviewImageUrl = null;
        if (img && renewedUrl) {
          img.src = renewedUrl;
        } else if (img) {
          img.src = this.defaultUserImage;
        }
      },
      error: () => {
        img.src = this.defaultUserImage;
      },
      complete: () => {
        this.isRefreshingPreviewImage = false;
      }
    });
  }


  isEmailValid() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.form.get('email').value);
}

  openNew(){
    this.displayModalApi = false
    this.form.reset()
    this.resetImageState()
    this.form.get('ativo').enable()
    this.form.get('usuario_interno').enable()
    this.form.get('empresa_id').enable()

    if (this.isUsuarioExterno) {
      this.form.get('ativo').setValue(true)
      this.form.get('usuario_interno').setValue(false)
      this.form.get('empresa_id').setValue(null)
      this.form.get('ativo').disable()
      this.form.get('usuario_interno').disable()
    } else {
      this.form.get('ativo').setValue(true)
      this.form.get('usuario_interno').setValue(false)
    }
    this.setupUsuarioInternoObserver()
    this.displayModal = true
  }

  openNewApi() {
    this.formApi.reset()
    this.formApi.get('ativo').setValue(true)
    this.displayModalApi = true
    this.setupEmpresaIdObserver()
  }

  index(){
    this.data = []
    this.usuarioService.listarUsuarios().subscribe(json => {
     this.data = (json || []).map((usuario: any) => this.adicionarPerfilNaListagem(usuario));
     setTimeout(() => {
       this.calculateScrollHeight();
     }, 200);
    })
  }

  private listPerfisParaListagem(): void {
    this._grupoUsuarioService.index().subscribe((grupos: any[]) => {
      this.perfisPorId.clear();

      (grupos || []).forEach((grupo: any) => {
        const id = this.normalizarGrupoUsuarioId(grupo?.id);
        if (id && typeof grupo?.nome === 'string' && grupo.nome.trim()) {
          this.perfisPorId.set(id, grupo.nome);
        }
      });

      this.data = this.data.map((usuario: any) => this.adicionarPerfilNaListagem(usuario));
    });
  }

  getNomePerfil(usuario: any): string {
    const grupoUsuarioId = this.normalizarGrupoUsuarioId(this.extractGrupoUsuarioId(usuario));
    return grupoUsuarioId ? this.perfisPorId.get(grupoUsuarioId) || 'Sem perfil' : 'Sem perfil';
  }

  private adicionarPerfilNaListagem(usuario: any): any {
    return {
      ...usuario,
      perfil: this.getNomePerfil(usuario),
    };
  }

  private normalizarGrupoUsuarioId(id: any): string | null {
    if (id === null || id === undefined) {
      return null;
    }

    const valor = String(id).trim();
    return valor && valor !== 'null' ? valor : null;
  }

  listEmpresas(){
    this.pessoaService.listEmpresas().subscribe(json => {
      this.preencherDropDownEmpresas(json);
    })
  }

  listGruposUsuario(usuario_interno: boolean = false, onLoaded?: () => void){
    const currentRequestId = ++this.gruposRequestId;
    this.dropDownGrupos = [{
      value: null, label: 'Selecione'
    }]
    const concluir = () => {
      if (currentRequestId === this.gruposRequestId) {
        onLoaded?.();
      }
    };
    this._grupoUsuarioService.indexFiltered(usuario_interno).subscribe({
      next: (json) => {
        if (currentRequestId !== this.gruposRequestId) {
          return;
        }

        (Array.isArray(json) ? json : []).forEach((item: any) => {
          if (item?.ativo == true) {
            this.dropDownGrupos.push({
              value: item.id, label: item.nome
            })
          }
        })
        concluir();
      },
      error: () => concluir()
    })
  }

  setupUsuarioInternoObserver(skipInitialLoad: boolean = false) {
    if (this.usuarioInternoSubscription) {
      this.usuarioInternoSubscription.unsubscribe();
    }

    if (!skipInitialLoad) {
      // Garantir que o filtro inicial está correto baseado no valor atual
      // Se null ou undefined, trata como false
      const usuarioInternoAtual = this.form.get('usuario_interno').value;
      const filtroInicial = this.normalizeBoolean(usuarioInternoAtual);
      this.listGruposUsuario(filtroInicial);
    }
    
    this.usuarioInternoSubscription = this.form.get('usuario_interno').valueChanges.subscribe((usuario_interno) => {
      const grupoAtual = this.form.get('grupo_usuario_id').value;
      // Aplicar filtro baseado no novo valor (true ou false)
      // Se null ou undefined, trata como false
      const filtroValue = this.normalizeBoolean(usuario_interno);
      this.listGruposUsuario(filtroValue);
      
      // Se o grupo atual não estiver na nova lista, limpa o campo
      setTimeout(() => {
        const grupoExiste = this.dropDownGrupos.find(g => this.areSameValue(g.value, grupoAtual));
        if (!grupoExiste && !this.isGrupoUsuarioNaoSelecionado(grupoAtual)) {
          this.form.get('grupo_usuario_id').setValue(null);
        }
      }, 200);
    });
  }

  save(){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailRegex.test(this.form.get('email').value) == false){
      this.messageService.add({severity:'warn', summary: 'E-mail inválido', detail: 'Informe um E-mail válido e tente novamente!'});
      return
    }
    let form: any = { ...this.form.getRawValue() }
    form.password = typeof form.password === 'string' ? form.password.trim() : form.password;

    if (this.isGrupoUsuarioNaoSelecionado(form.grupo_usuario_id)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Perfil obrigatório',
        detail: 'Selecione um perfil antes de salvar o cadastro.',
      });
      return;
    }

    if (form.id != null && !form.password) {
      delete form.password;
    }

    if (this.isUsuarioExterno) {
      form.usuario_interno = false
    }
    const empresasSelecionadas = Array.isArray(form.empresa_id) ? form.empresa_id : []
    if (form.usuario_interno === false && empresasSelecionadas.length === 0) {
      this.messageService.add({
        severity:'warn',
        summary: 'Empresa obrigatória',
        detail: 'Selecione ao menos uma empresa para o usuário.',
      });
      return
    }
    let empresas: any[] = []
    if(empresasSelecionadas.length){
      empresasSelecionadas.map(item => {
        empresas.push({
          id:item.value
        })
      })
    }
   
    const formData = this.buildUsuarioFormData(form, empresas)
    const request$ = form.id == null
      ? this.usuarioService.storeMultipart(formData)
      : this.usuarioService.updateMultipart(formData, form.id);

    this.loading = true;
    request$.subscribe({
      next: (json) => {
        this.index()
        this.syncCurrentUserIfNeeded(json)
        this.displayModal = false
        this.resetImageState()
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao salvar',
          detail: this.extractApiErrorMessage(err, 'Não foi possível salvar o usuário.'),
        });
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  private showDownloadConfirmation(needsApiKey: boolean, needsSecret: boolean): Promise<boolean> {
    return new Promise((resolve) => {
      let message = 'Você ainda não baixou:';
      if (needsApiKey) message += '\n- API Key';
      if (needsSecret) message += '\n- Secret';
      message += '\n\nDeseja baixar agora?';
      
      this.confirmationService.confirm({
        key: 'globalConfirm',
        message: message,
        header: 'Confirmar Download',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sim',
        rejectLabel: 'Não, salvar mesmo assim',
        accept: () => {
          if (needsApiKey) this.downloadFile('api_key.txt', this.formApi.get('api_key').value);
          if (needsSecret) this.downloadFile('secret.txt', this.formApi.get('secret').value);
          resolve(true);
        },
        reject: () => {
          resolve(true);
        }
      });
    });
  }

  async saveApi () {
    const needsApiKeyConfirm = this.formApi.get('api_key').value && !this.apiKeyDownloaded && !this.isEditing;
    const needsSecretConfirm = this.formApi.get('secret').value && !this.secretDownloaded;

    if (needsApiKeyConfirm || needsSecretConfirm) {
      const confirmed = await this.showDownloadConfirmation(needsApiKeyConfirm, needsSecretConfirm);
      if (!confirmed) {
        return;
      }
    }
    let form = this.formApi.value;
    let params = {
      usuario: {
        ativo: form.ativo,
        name: form.name,
        empresa_id: form.empresa_id,
        email: form.email,
        password: form.password,
        api_key: form.api_key,
        secret: form.secret,
        tipo: 1,
      }
    }

    if(form.id == null){
      this.usuarioService.store(params).subscribe({
        next: (json) => {
          this.index()
          this.displayModalApi = false
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro ao salvar',
            detail: this.extractApiErrorMessage(err, 'Não foi possível salvar o usuário.'),
          });
        }
      })
    } else {
      this.usuarioService.update(params, form.id).subscribe({
        next: (json) => {
          this.index()
          this.displayModalApi = false
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro ao salvar',
            detail: this.extractApiErrorMessage(err, 'Não foi possível salvar o usuário.'),
          });
        }
      })
    }

    this.apiKeyDownloaded = false;
    this.secretDownloaded = false;
    this.isEditing = false;
  }

  generateRandomPassword(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({length}, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  }

  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  generateRandomSecret(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    return Array.from({length}, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  }

  setupEmpresaIdObserver() {
    if (this.empresaIdSubscription) {
      this.empresaIdSubscription.unsubscribe();
    }
    
    this.empresaIdSubscription = this.formApi.get('empresa_id').valueChanges.pipe(
      distinctUntilChanged()
    ).subscribe((empresaId) => {
      if (this.isEditing) return;

      const empresaSelecionada = this.dropDownEmpresas.find(e => e.value === empresaId);
      
      if (empresaSelecionada) {
        this.formApi.patchValue({
          name: `${empresaSelecionada.label}-api`,
          email: `${empresaSelecionada.label.toLowerCase().replace(/\s+/g, '_')}@email.com`,
          password: this.generateRandomPassword(6),
          api_key: this.generateUUID(),
          secret: this.generateRandomSecret(36)
        }, { emitEvent: false });
        
        this.apiKeyDownloaded = false;
        this.secretDownloaded = false;
      }
    });
  }

  downloadFile(filename: string, content: string) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    
    if (filename === 'api_key.txt') {
      this.apiKeyDownloaded = true;
    } else if (filename === 'secret.txt') {
      this.secretDownloaded = true;
    }
  }

  generateNewSecret() {
    const newSecret = this.generateRandomSecret(36);
    this.formApi.patchValue({
      secret: newSecret
    });
    this.secretDownloaded = false;
  }

  private mapEmpresasSelecionadas(empresas: any[] | null | undefined): any[] {
    if (!Array.isArray(empresas)) {
      return [];
    }

    return empresas.reduce((selecionadas: any[], item: any) => {
      const value = item?.empresa_id ?? item?.empresa?.id ?? item?.value;
      const label = item?.empresa?.nome ?? item?.nome ?? item?.label;
      if (value === null || value === undefined || !label) {
        return selecionadas;
      }

      selecionadas.push({ label, value });
      return selecionadas;
    }, []);
  }

  private preencherDropDownEmpresas(empresasJson: any[] | null | undefined): void {
    this.dropDownEmpresas = [];
    (Array.isArray(empresasJson) ? empresasJson : [])
      .filter((item: any) => item?.ativo === true)
      .forEach((item: any) => {
        this.dropDownEmpresas.push({
          value: item.id, label: item.nome
        });
      });
  }

  edit(event){
    this.displayModalApi = false
    if (this.usuarioInternoSubscription) {
      this.usuarioInternoSubscription.unsubscribe();
    }
    this.form.reset()
    this.resetImageState()
    this.form.get('ativo').enable()
    this.form.get('usuario_interno').enable()
    this.form.get('empresa_id').enable()

    this.usuarioService.show(event.id).subscribe({
      next: (json) => {
        const usuario_interno = this.normalizeBoolean(json.usuario_interno);
        const grupoFilterInterno = this.isUsuarioExterno ? false : usuario_interno;
        const grupoUsuarioIdRaw = this.extractGrupoUsuarioId(json);
        const empresas = this.mapEmpresasSelecionadas(json?.empresas);

        const abrirModal = (empresaIdValue?: any | null) => {
          this.listGruposUsuario(grupoFilterInterno, () => {
            const grupoOption = this.dropDownGrupos.find((g) => this.areSameValue(g.value, grupoUsuarioIdRaw));
            const grupoUsuarioId = grupoOption ? grupoOption.value : null;

            this.setupUsuarioInternoObserver(true);

            const usuarioInternoForm = this.isUsuarioExterno ? false : usuario_interno;

            this.form.patchValue({
              ...json,
              url_imagem_usuario: json.url_imagem_usuario ?? null,
              usuario_interno: usuarioInternoForm,
              grupo_usuario_id: grupoUsuarioId
            }, { emitEvent: false });

            this.imagePreviewUrl = json.url_imagem_usuario ?? null;

            if (!grupoOption) {
              this.form.get('grupo_usuario_id').setValue(null, { emitEvent: false });
            }

            if (empresaIdValue !== undefined) {
              this.form.get('empresa_id').setValue(empresaIdValue, { emitEvent: false });
            }

            if (this.isUsuarioExterno) {
              this.form.get('usuario_interno').setValue(false, { emitEvent: false });
              this.form.get('usuario_interno').disable();
              this.form.get('ativo').disable();
            }

            this.displayModal = true;
          });
        };

        if (this.isUsuarioExterno) {
          let empresasSel = empresas.filter((item) => this.dropDownEmpresas.some(e => e.value === item.value));
          if (!empresasSel.length && this.dropDownEmpresas.length) {
            empresasSel = this.dropDownEmpresas.map(e => ({ label: e.label, value: e.value }));
          }
          abrirModal(empresasSel.length ? empresasSel : null);
          return;
        }

        if (Array.isArray(json?.empresas)) {
          this.pessoaService.listEmpresas().subscribe({
            next: (empresasJson) => {
              this.preencherDropDownEmpresas(empresasJson);
              abrirModal(empresas.length ? empresas : null);
            },
            error: () => abrirModal(empresas.length ? empresas : null)
          });
          return;
        }

        abrirModal();
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao abrir usuário',
          detail: this.extractApiErrorMessage(err, 'Não foi possível carregar os dados do usuário.'),
        });
      }
    })
  }

  editApi(event) {
    this.formApi.reset()
    this.isEditing = true;
    this.apiKeyDownloaded = true;
    this.secretDownloaded = true;

    this.usuarioService.show(event.id).subscribe(json => {
      this.formApi.patchValue(json);
      this.displayModalApi = true;
    })
  }

  confirmarEnvioConvite(usuario: any): void {
    const nome = usuario.name || usuario.email || `ID ${usuario.id}`;
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente enviar o e-mail de convite para "${nome}" (${usuario.email})?`,
      header: 'Confirmar envio de convite',
      icon: 'pi pi-envelope',
      acceptLabel: 'Sim, enviar',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-success',
      accept: () => this.enviarConvite(usuario),
    });
  }

  private enviarConvite(usuario: any): void {
    this.enviandoConviteId = usuario.id;
    this.usuarioService.enviarConvite(usuario.id).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Convite enviado',
          detail: `E-mail de convite enviado para ${usuario.email}.`,
        });
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao enviar convite',
          detail: this.extractApiErrorMessage(err, 'Não foi possível enviar o e-mail de convite.'),
        });
      },
      complete: () => {
        this.enviandoConviteId = null;
      },
    });
  }

  /**
   * Confirmação Sim/Não antes de excluir. Chama DELETE /api/usuario/{id}.
   * Documentação: 204 sucesso; 401 não autenticado; 403 não pode excluir a si mesmo; 404 usuário não encontrado.
   */
  confirmarExclusao(usuario: any): void {
    const nome = usuario.name || usuario.email || `ID ${usuario.id}`;
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente excluir o usuário "${nome}" (código ${usuario.id})?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.excluirUsuario(usuario.id),
    });
  }

  private excluirUsuario(id: number): void {
    this.usuarioService.destroy(id).subscribe({
      next: () => {
        this.data = this.data.filter((item: any) => item.id !== id);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Usuário excluído com sucesso.',
        });
        setTimeout(() => this.calculateScrollHeight(), 200);
      },
      error: (err) => {
        const status = err?.status;
        const body = err?.error || {};
        const msg = body?.message || body?.error || 'Não foi possível excluir o usuário.';
        if (status === 404) {
          this.data = this.data.filter((item: any) => item.id !== id);
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: msg,
          });
        } else if (status === 403) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Não permitido',
            detail: msg,
          });
        } else if (status === 401) {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg,
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg,
          });
        }
      },
    });
  }

  private buildUsuarioFormData(form: any, empresas: any[]): FormData {
    const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {
      if (key === 'empresa_id' || key === 'url_imagem_usuario') {
        return;
      }

      if (value === null || value === undefined || value === '') {
        return;
      }

      formData.append(`usuario[${key}]`, String(value));
    });

    empresas.forEach((empresa, index) => {
      formData.append(`empresas[${index}][id]`, String(empresa.id));
    });

    if (this.selectedImageFile) {
      formData.append('imagem_usuario', this.selectedImageFile, this.selectedImageFile.name);
    } else if (this.imagemRemovida) {
      formData.append('remover_imagem', '1');
    }

    return formData;
  }

  hasEmpresaSelecionada(): boolean {
    const empresasSelecionadas = this.form.get('empresa_id')?.value;
    return Array.isArray(empresasSelecionadas) && empresasSelecionadas.length > 0;
  }

  clearImage(): void {
    this.selectedImageFile = null;
    this.imagePreviewUrl = null;
    this.imagemRemovida = true;
    this.form.patchValue({ url_imagem_usuario: null });
  }

  private resetImageState(): void {
    this.selectedImageFile = null;
    this.imagePreviewUrl = null;
    this.imagemRemovida = false;
    this.isRefreshingPreviewImage = false;
    this.lastRetriedPreviewImageUrl = null;
  }

  private extractApiErrorMessage(err: any, fallback: string): string {
    const body = err?.error;

    if (!body) {
      return fallback;
    }

    if (typeof body.message === 'string' && body.message.trim()) {
      return body.message;
    }

    const errors = body.errors;

    if (Array.isArray(errors)) {
      const first = errors.find((item) => typeof item === 'string' && item.trim());
      if (first) {
        return first;
      }
    }

    if (errors && typeof errors === 'object') {
      for (const value of Object.values(errors)) {
        if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string') {
          return value[0];
        }

        if (typeof value === 'string' && value.trim()) {
          return value;
        }
      }
    }

    return fallback;
  }

  private syncCurrentUserIfNeeded(usuario: any): void {
    const currentUser = JSON.parse(localStorage.getItem('user') ?? 'null');
    if (!currentUser || currentUser.id !== usuario?.id) {
      return;
    }

    localStorage.setItem('user', JSON.stringify({
      ...currentUser,
      ...usuario,
    }));
  }
}
